module.exports = __webpack_public_path__ + "img/growcify-app-banner-1.1ec24d01.png";